// src/app/[lang]/shop/carpets/DialogProductSearch.jsx

'use client';

import { useEffect, useRef } from 'react';
import { FiltersIcon } from '@/containers/Icons';
import CloseIcon from '@mui/icons-material/Close';
import styles from './DialogProductSearch.module.scss';


export default function ProductSearchDialog({ filtersTranslations, children }) {

  const dialogRef = useRef(null);

  // Open dialog using showModal() method
  const openDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.show();
    }
  };

  // Close dialog using close() method
  const closeDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
    }
  };

  // Close dialog if the screen size is enlarged
  const checkScreenSize = () => {
    const screenWidth = window.innerWidth;
    const remInPixels = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    if (screenWidth > 55 * remInPixels && dialogRef.current?.open) {
      closeDialog();
    }
  };

  // Attach resize event listener once
  useEffect(() => {
    window.addEventListener('resize', checkScreenSize);
    checkScreenSize(); // Initial check
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  // Handle clicks on the backdrop (dialog itself)
  const handleBackdropClick = (event) => {
    // Only close if the click was directly on the dialog element
    // and not on any of its children
    if (event.target === dialogRef.current) {
      closeDialog();
    }
  };

  return (
    <>
      <button onClick={openDialog} type="button" className="btn-std-inv w100">
        {FiltersIcon} {filtersTranslations.openDialogText}
      </button>
      <dialog
        ref={dialogRef}
        className={`${styles.dialogContainer} glass`}
        onClick={handleBackdropClick}
      >
        <div className={styles.dialogContent}>
          <button onClick={closeDialog}>
            <CloseIcon style={{ color: 'var(--clr-text)' }} /> Close
          </button>
          <div className="sm-width">
            <h2 className="sr-only">{filtersTranslations.h2mobile}</h2>
            {children}
          </div>
        </div>
      </dialog>
    </>
  );
}
